import { useContext } from 'react';
import { ConfigContext } from '../contexts/config-context';

export function ConfigLoader({ children }) {
    const { error } = useContext(ConfigContext);

    if (error) {
        console.warn('App config failed to load, using fallback configuration:', error);
    }

    // Always render children immediately - config loads in background
    return children;
}